import { ReactSDKClient } from '@optimizely/react-sdk';
import useOptimizely from './useOptimizely';

export const useLiveRamp = (optimizely: ReactSDKClient | null) =>
    useOptimizely(optimizely, 'liveramp-consent-banner');

export default useLiveRamp;
